import { HStack, SimpleGrid, VStack } from "@chakra-ui/react";
import { useEffect, useState } from "react";
import Pagination from "../../../components/Pagination";
import { Empty } from "../../../components/card/Empty";
import { PageContainer } from "../../../components/container/PageContainer";
import { SupplierCard } from "../../../components/dashboard_reseller/SupplierCard";
import SearchInput from "../../../components/input/SearchInput";
import { MenuSort } from "../../../components/menu/MenuSort";
import { CardSkeleton } from "../../../components/skeleton/CardSkeleton";
import { menuSortSupplierList } from "../../../constants/ListMenuSort";
import { pickSupplierProduct } from "../../../constants/PageNavs";
import { PaginationInterface } from "../../../constants/Pagination";
import { SupplierList } from "../../../constants/Supplier";
import useCustomToast from "../../../lib/useCustomToast";
import { axiosReseller } from "../../../utils/AxiosInstance";

export const ListSupplier = () => {
  const [data, setData] = useState<SupplierList[] | undefined>(undefined);
  const [search, setSearch] = useState<string>("");
  const [pagination, setPagination] = useState<PaginationInterface | undefined>(
    undefined
  );
  const [sort, setSort] = useState<string>("");
  const [loaded, setLoaded] = useState<boolean>(false);
  const [page, setPage] = useState<number>(1);
  const toast = useCustomToast();

  useEffect(() => {
    axiosReseller
      .get(
        `/v1/reseller/list-supplier?page=${page}&sort=${sort}&search=${search}`
      )
      .then((res) => {
        setPagination(res.data.data.paginator);
        setData(res.data.data.data);
      })
      .catch((err) => {
        toast({
          description: err?.response?.data?.message || "",
        });
      })
      .finally(() => {
        setLoaded(true);
      });
  }, [page, search, sort]);

  return (
    <PageContainer navs={pickSupplierProduct}>
      <VStack className="root-list-supplier" w={"100%"} alignItems={"start"}>
        <HStack w={"100%"} mt={4} justify={"space-between"}>
          <SearchInput
            flex={2}
            onConfirm={(input) => {
              setSearch(input);
            }}
          />

          <MenuSort
            item={menuSortSupplierList}
            children={undefined}
            onSelected={(input) => {
              setSort(`${input?.note}`);
            }}
          />
        </HStack>

        {!loaded ? (
          <CardSkeleton row={4} column={4} height={138} mt={4} />
        ) : data && data?.length > 0 ? (
          <SimpleGrid
            className="simplegrid"
            w={"100%"}
            columns={[2, null, 3, 3, 4, 5, null, 8, 10]}
            gap={4}
            mt={4}
          >
            {data?.map((item, i) => (
              <SupplierCard key={item.id} data={item} />
            ))}
          </SimpleGrid>
        ) : (
          <Empty />
        )}

        {loaded && pagination && (
          <Pagination
            mt={4}
            totalItems={pagination.total}
            pageSize={pagination.per_page}
            onPageChange={(page) => {
              setPage(page);
            }}
          />
        )}
      </VStack>
    </PageContainer>
  );
};
